import {useVerifiedPermissions} from '@flexinet/auth-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton.tsx';


export const usePageHeaderTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes('DeleteAccountApplication')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('CreateAccountApplication')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return {tools};
};
